import { useIsLoggingIn } from '@order/AuthMachine';
import type { Customer } from '@order/graphql';

import { useCurrentCustomerQuery } from '../GraphQL/CurrentCustomer.query.generated';

export const useCustomerData = () => {
  const isLoggingIn = useIsLoggingIn();

  // NOTE: `Customer` network requests are managed by the `Auth` state machine
  const [customerResponse] = useCurrentCustomerQuery({
    requestPolicy: 'cache-only',
  });

  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- @REVIEW
  const customer = customerResponse.data?.currentCustomer || emptyCustomer;
  const isDataResolved = typeof customerResponse.data !== 'undefined';
  const isFetchingCustomer = isLoggingIn;
  const isCustomerLoaded =
    isDataResolved &&
    !customerResponse.fetching &&
    Boolean(customerResponse.data?.currentCustomer?.id) &&
    Boolean(customer?.id);

  // ────────────────────────────────────────────────────────────────────

  return {
    customer,
    isFetchingCustomer,
    isCustomerLoaded,
  };
};

// ────────────────────────────────────────────────────────────────────────────────

export const emptyCustomer: Partial<Customer> = {};
